import React, { useMemo } from "react";
import { View } from "react-native";
import { useScreenSize } from "../../../hooks/useScreenSize";
import { Text } from "../../atoms/text/Text";
import { ButtonIcon } from "../buttonIcon/ButtonIcon";
import { style as toastStyle } from "./Toast.style";
var ToastVariant;
(function (ToastVariant) {
    ToastVariant["INFO"] = "INFO";
    ToastVariant["ERROR"] = "ERROR";
    ToastVariant["SUCCESS"] = "SUCCESS";
})(ToastVariant || (ToastVariant = {}));
const styleVariant = (variant) => variant.toLowerCase();
const Toast = ({ body, title, onClose, testID, variant = ToastVariant.INFO, style: customStyle, }) => {
    const screenSize = useScreenSize();
    const style = useMemo(() => toastStyle(), []);
    return (React.createElement(View, { style: [style.toast, style[styleVariant(variant)], customStyle?.toast], testID: testID },
        React.createElement(View, { style: style.content },
            title && (React.createElement(Text, { level: screenSize === "S" ? 3 : 2, style: [style.title, customStyle?.title], testID: "toast-title" }, title)),
            React.createElement(Text, { level: 2, style: [style.body, customStyle?.body], testID: "toast-body", variant: "detail" }, body)),
        onClose && (React.createElement(ButtonIcon, { name: "close", style: { button: [style.button, customStyle?.closeButton] }, testID: "toast-close-button", onPress: onClose }))));
};
export { Toast, ToastVariant };
